export default {
  pdfPageNavigator: {
    pagina: 'Page',
    de: 'of'
  }
};
